import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Loader } from 'sfy-react'
import ChatLayout from './routes/DemoChatbot/ChatLayout'
import Login from './routes/Login'
import Home from './routes/DemoChatbot/Home'
import Chatbot from './routes/DemoChatbot/Chatbot'

const App = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route element={<ChatLayout />}>
          <Route path='/home' element={<Home />} />
          <Route path='/chat' element={<Chatbot />} />
        </Route>
        <Route path='/login/*' element={<Login />} />
        <Route path='*' element={<Navigate to='/home' replace />}></Route>
      </Routes>
    </Suspense>
  )
}

export default App
